// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"footerLinks_footerLinks__GtHHk"};